//
//
//
//

import Lottie from 'vue-lottie'
export default {
  name: 'rb-animated-glasses',
  components: {
    Lottie,
  },
  props: {
    options: {
      type: Object,
      default: () => ({}),
    },
    width: Number,
    height: Number,
  },
}
